import server from './server'

export const fetchTicketShowTimeAvailability = (ticketId, payload) => {
  return server.get(`/tickets/${ticketId}/availability`, { params: payload })
}
